var _defs, _rect, _defs2, _path, _circle, _circle2, _line, _line2, _rect2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViolin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "statsplot",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#87f2d4",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8b6ce7",
    stopOpacity: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 160,
    height: 420,
    fill: "url(#statsplot)",
    rx: 14
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "hViolinLines",
    width: 3,
    height: 3,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "visx-pattern-line",
    d: "M 0,1.5 l 3,0",
    stroke: "#ced4da",
    strokeWidth: 1,
    strokeLinecap: "square",
    shapeRendering: "auto"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "visx-group",
    transform: "translate(0, 40)"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "visx-violin",
    d: "M80,273C80,273,79.83333333333333,269.3333333333333,80,266C80.16666666666667,262.6666666666667,80.5,257.5,81,253C81.5,248.5,82.5,243.66666666666666,83,239C83.5,234.33333333333334,83.33333333333333,229.5,84,225C84.66666666666667,220.5,86.33333333333333,216.5,87,212C87.66666666666667,207.5,87.16666666666667,202.66666666666666,88,198C88.83333333333333,193.33333333333334,90.66666666666667,188.5,92,184C93.33333333333333,179.5,94.83333333333333,175.5,96,171C97.16666666666667,166.5,98.33333333333333,161.66666666666666,99,157C99.66666666666667,152.33333333333334,100.33333333333333,147.5,100,143C99.66666666666667,138.5,98,134.5,97,130C96,125.5,94.5,120.66666666666667,94,116C93.5,111.33333333333333,94.66666666666667,106.5,94,102C93.33333333333333,97.5,90.66666666666667,93.5,90,89C89.33333333333333,84.5,90.5,79.66666666666667,90,75C89.5,70.33333333333333,87.83333333333333,65.5,87,61C86.16666666666667,56.5,85.83333333333333,52.5,85,48C84.16666666666667,43.5,82.66666666666667,38.666666666666664,82,34C81.33333333333333,29.333333333333336,81.16666666666667,24.5,81,20C80.83333333333333,15.5,81.16666666666667,10.333333333333332,81,7C80.83333333333333,3.666666666666667,80,0,80,0 L80,0C80,0,79.16666666666667,3.666666666666667,79,7C78.83333333333333,10.333333333333332,79.16666666666667,15.5,79,20C78.83333333333333,24.5,78.66666666666667,29.333333333333336,78,34C77.33333333333333,38.666666666666664,75.83333333333333,43.5,75,48C74.16666666666667,52.5,73.83333333333333,56.5,73,61C72.16666666666667,65.5,70.5,70.33333333333333,70,75C69.5,79.66666666666667,70.66666666666667,84.5,70,89C69.33333333333333,93.5,66.66666666666667,97.5,66,102C65.33333333333333,106.5,66.5,111.33333333333333,66,116C65.5,120.66666666666667,64,125.5,63,130C62,134.5,60.333333333333336,138.5,60,143C59.666666666666664,147.5,60.333333333333336,152.33333333333334,61,157C61.666666666666664,161.66666666666666,62.833333333333336,166.5,64,171C65.16666666666667,175.5,66.66666666666667,179.5,68,184C69.33333333333333,188.5,71.16666666666667,193.33333333333334,72,198C72.83333333333333,202.66666666666666,72.33333333333333,207.5,73,212C73.66666666666667,216.5,75.33333333333333,220.5,76,225C76.66666666666667,229.5,76.5,234.33333333333334,77,239C77.5,243.66666666666666,78.5,248.5,79,253C79.5,257.5,79.83333333333333,262.6666666666667,80,266C80.16666666666667,269.3333333333333,80,273,80,273 Z",
    stroke: "#dee2e6",
    fill: "url(#hViolinLines)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "visx-group visx-boxplot",
    transform: "translate(0, 0)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "visx-boxplot-outlier",
    cx: 80,
    cy: 321,
    r: 4,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "visx-boxplot-outlier",
    cx: 80,
    cy: -1,
    r: 4,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillOpacity: 0.3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "visx-boxplot-max",
    x1: 76,
    y1: 0,
    x2: 84,
    y2: 0,
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "visx-boxplot-max-to-third",
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 102,
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "visx-boxplot-box",
    x: 72,
    y: 102,
    width: 16,
    height: 69,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillOpacity: 0.3,
    rx: 2,
    ry: 2
  })), /*#__PURE__*/React.createElement("line", {
    className: "visx-boxplot-median",
    x1: 72,
    y1: 140,
    x2: 88,
    y2: 140,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    style: {
      stroke: "white"
    }
  }), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "visx-boxplot-min-to-first",
    x1: 80,
    y1: 171,
    x2: 80,
    y2: 273,
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "visx-boxplot-min",
    x1: 76,
    y1: 273,
    x2: 84,
    y2: 273,
    stroke: "#FFFFFF",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViolin);
export default __webpack_public_path__ + "static/media/Violin.4ff001fd654cd35c94bb10fb343a0382.svg";
export { ForwardRef as ReactComponent };